module.exports = __webpack_public_path__ + "static/media/linkedin.d018349e.svg";